import { useContext } from "react";

import { SignalRContext } from "./SignalRProvider";

export const getHubUrl = () => {
  // Prefer dedicated SignalR URL if set (decouples SignalR from REST API URL)
  const signalRUrl = import.meta.env.VITE_SIGNALR_URL;
  if (signalRUrl) {
    return signalRUrl;
  }

  // Derive hub URL from VITE_API_URL.
  // PACE: URL ends in /v1 — append /hubs/notification (APIM routes it through).
  // POC:  URL ended in /api — strip suffix first, then append.
  const apiUrl = import.meta.env.VITE_API_URL;
  if (apiUrl) {
    const base = apiUrl.replace(/\/+$/, "");
    return `${base}/hubs/notification`;
  }

  // Dev server fallback (Vite proxy)
  return "/hubs/notification";
};

export function useSignalR() {
  return useContext(SignalRContext);
}
